import { Components, Theme } from '@mui/material/styles';

export const muiIconOverride: Components<Theme>['MuiIcon'] = {
  styleOverrides: {
    root: {
      fontSize: 20,
    },
  },
};
